import { useTheme } from "./ThemeContext";

const ALLOWED_ROLES = ["admin", "coach", "analyst", "doctor", "physiotherapist"];

export { ALLOWED_ROLES };

export default function BlockedPage({ onLogout }) {
  const { isDarkMode } = useTheme();

  return (
    <div
      className={`flex items-center justify-center min-h-screen px-4 ${
        isDarkMode ? "bg-gray-950 text-gray-100" : "bg-white text-gray-900"
      }`}
    >
      <div
        className={`max-w-md w-full rounded-2xl border p-8 text-center shadow-lg ${
          isDarkMode ? "bg-gray-900 border-gray-700" : "bg-white border-gray-200"
        }`}
      >
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-100 text-red-600">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-7 w-7"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M18.364 5.636a9 9 0 11-12.728 0M12 9v4m0 4h.01"
            />
          </svg>
        </div>

        <h1 className="text-xl font-bold mb-2">Access Blocked</h1>

        <p className={`text-sm mb-6 ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
          Your account does not have the required permissions to access this
          application. Please contact a club administrator to have your role
          updated.
        </p>

        {onLogout && (
          <button
            onClick={onLogout}
            className="px-4 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold transition"
          >
            Log out
          </button>
        )}
      </div>
    </div>
  );
}
